export default function PrivacyPolicy() {
  return (
    <section id="privacy" className="py-32 bg-white">
      <div className="max-w-4xl mx-auto px-8">
        <div className="mb-12">
          <div className="inline-block bg-purple-100 text-purple-700 text-xs font-bold px-4 py-2 rounded-full mb-6">
            LEGAL
          </div>
          <h2 className="text-5xl font-bold text-[#0A1628]">
            Privacy &amp; Security Policy
          </h2>
        </div>

        <div className="space-y-12">
          <div>
            <h3 className="text-2xl font-bold text-[#0A1628] mb-4">Our Commitment to Privacy</h3>
            <p className="text-gray-700 text-base leading-relaxed mb-4">
              At ESVICOL LTDA, we are committed to protecting your privacy and ensuring the security of your personal information. This Privacy Policy outlines how we collect, use, and safeguard your data when you use our VPN service.
            </p>
            <div className="bg-[#F0F4F8] rounded-xl p-6">
              <p className="text-[#0A1628] font-semibold text-sm">
                <strong>Key Commitment:</strong> We operate under a strict no-log policy. We do not track, collect, or store any information about your online activities while using our VPN service.
              </p>
            </div>
          </div>

          <div>
            <h3 className="text-2xl font-bold text-[#0A1628] mb-4">Information We Collect</h3>
            <p className="text-gray-700 text-base leading-relaxed mb-4">
              To provide you with our VPN service, we may collect the following limited information:
            </p>
            <ul className="space-y-3">
              <li className="flex items-start gap-3">
                <span className="w-2 h-2 bg-[#00D9FF] rounded-full mt-2 flex-shrink-0"></span>
                <span className="text-gray-700 text-base"><strong>Account Information:</strong> Email address and payment information necessary for account creation and billing purposes.</span>
              </li>
              <li className="flex items-start gap-3">
                <span className="w-2 h-2 bg-[#00D9FF] rounded-full mt-2 flex-shrink-0"></span>
                <span className="text-gray-700 text-base"><strong>Technical Data:</strong> Device type, operating system, and app version to ensure compatibility and improve service quality.</span>
              </li>
              <li className="flex items-start gap-3">
                <span className="w-2 h-2 bg-[#00D9FF] rounded-full mt-2 flex-shrink-0"></span>
                <span className="text-gray-700 text-base"><strong>Connection Data:</strong> Aggregated and anonymized connection statistics to maintain server performance.</span>
              </li>
            </ul>
          </div>

          <div>
            <h3 className="text-2xl font-bold text-[#0A1628] mb-4">What We Do NOT Collect</h3>
            <p className="text-gray-700 text-base leading-relaxed mb-4">
              We want to be crystal clear about what we do not collect:
            </p>
            <ul className="space-y-3">
              <li className="flex items-start gap-3">
                <span className="w-2 h-2 bg-[#00D9FF] rounded-full mt-2 flex-shrink-0"></span>
                <span className="text-gray-700 text-base">Your browsing history or the websites you visit</span>
              </li>
              <li className="flex items-start gap-3">
                <span className="w-2 h-2 bg-[#00D9FF] rounded-full mt-2 flex-shrink-0"></span>
                <span className="text-gray-700 text-base">DNS queries or any data about your internet traffic</span>
              </li>
              <li className="flex items-start gap-3">
                <span className="w-2 h-2 bg-[#00D9FF] rounded-full mt-2 flex-shrink-0"></span>
                <span className="text-gray-700 text-base">Connection timestamps or session duration</span>
              </li>
              <li className="flex items-start gap-3">
                <span className="w-2 h-2 bg-[#00D9FF] rounded-full mt-2 flex-shrink-0"></span>
                <span className="text-gray-700 text-base">Your IP address or the IP addresses you connect to</span>
              </li>
            </ul>
          </div>

          <div>
            <h3 className="text-2xl font-bold text-[#0A1628] mb-4">Data Security</h3>
            <p className="text-gray-700 text-base leading-relaxed mb-4">
              We implement industry-leading security measures to protect your information:
            </p>
            <ul className="space-y-3">
              <li className="flex items-start gap-3">
                <span className="w-2 h-2 bg-[#00D9FF] rounded-full mt-2 flex-shrink-0"></span>
                <span className="text-gray-700 text-base"><strong>AES-256 Encryption:</strong> All data transmitted through our VPN is encrypted with military-grade AES-256 encryption.</span>
              </li>
              <li className="flex items-start gap-3">
                <span className="w-2 h-2 bg-[#00D9FF] rounded-full mt-2 flex-shrink-0"></span>
                <span className="text-gray-700 text-base"><strong>Secure Protocols:</strong> We use OpenVPN, IKEv2, and WireGuard protocols for maximum security.</span>
              </li>
              <li className="flex items-start gap-3">
                <span className="w-2 h-2 bg-[#00D9FF] rounded-full mt-2 flex-shrink-0"></span>
                <span className="text-gray-700 text-base"><strong>Kill Switch:</strong> Automatic protection that blocks all internet traffic if the VPN connection drops.</span>
              </li>
            </ul>
          </div>

          <div>
            <h3 className="text-2xl font-bold text-[#0A1628] mb-4">Third-Party Sharing</h3>
            <p className="text-gray-700 text-base leading-relaxed">
              We do not sell, trade, or share your personal information with third parties for marketing purposes. We may share limited information with trusted service providers who assist us in operating our service, but only to the extent necessary and under strict confidentiality agreements.
            </p>
          </div>

          <div>
            <h3 className="text-2xl font-bold text-[#0A1628] mb-4">Your Rights</h3>
            <p className="text-gray-700 text-base leading-relaxed mb-4">
              You have the right to:
            </p>
            <ul className="space-y-3">
              <li className="flex items-start gap-3">
                <span className="w-2 h-2 bg-[#00D9FF] rounded-full mt-2 flex-shrink-0"></span>
                <span className="text-gray-700 text-base">Access the personal information we hold about you</span>
              </li>
              <li className="flex items-start gap-3">
                <span className="w-2 h-2 bg-[#00D9FF] rounded-full mt-2 flex-shrink-0"></span>
                <span className="text-gray-700 text-base">Request correction of any inaccurate information</span>
              </li>
              <li className="flex items-start gap-3">
                <span className="w-2 h-2 bg-[#00D9FF] rounded-full mt-2 flex-shrink-0"></span>
                <span className="text-gray-700 text-base">Request deletion of your account and associated data</span>
              </li>
              <li className="flex items-start gap-3">
                <span className="w-2 h-2 bg-[#00D9FF] rounded-full mt-2 flex-shrink-0"></span>
                <span className="text-gray-700 text-base">Withdraw consent for data processing at any time</span>
              </li>
            </ul>
          </div>

          <div>
            <h3 className="text-2xl font-bold text-[#0A1628] mb-4">Contact Us</h3>
            <p className="text-gray-700 text-base leading-relaxed mb-4">
              If you have any questions or concerns about this Privacy Policy or our data practices, please contact us:
            </p>
            <div className="bg-[#F0F4F8] rounded-xl p-6 space-y-2">
              <p className="text-[#0A1628] text-sm"><strong>Email:</strong> information@esvicolltda.com</p>
              <p className="text-[#0A1628] text-sm"><strong>Phone:</strong> +1 417-428-8656</p>
              <p className="text-[#0A1628] text-sm"><strong>Address:</strong> DIAGONAL 20 100 33, BUCARAMANGA, 680005, Colombia</p>
            </div>
          </div>

          <div>
            <p className="text-sm text-gray-600 italic">
              Last updated: January 2025. We reserve the right to update this Privacy Policy at any time. Any changes will be posted on this page with an updated revision date.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}
